// @mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Stack } from '@mui/material';
import {
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  useTable,
} from 'src/components/table';
import Scrollbar from 'src/components/scrollbar';
import { useSettingsContext } from 'src/components/settings';
import { getUserTelePackageResponses } from 'src/services/telehealth-packages.service';
import TelePackageTableRow from './telepackages-table-row';
import { useAuthContext } from '../../../auth/hooks';


// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'user_id', label: 'User ID' },
  { id: 'telecare_package_id', label: 'Telepackage ID' },
  { id: 'status', label: 'Status' },
];

export default function TelePackageResponseListView() {
  const settings = useSettingsContext();
  const { user } = useAuthContext();
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const table = useTable({
    defaultRowsPerPage: 10,
  });

  const notFound = !tableData.length;

  useEffect(() => {
    getUserTelePackageResponses(table.page + 1, table.rowsPerPage).then((res) => {
      if (res?.results) {
        setTableData(
          res.results.map((item) => ({
            user_id: item.user_id.id,
            user_name : item.user_id.username,
            doctor_id: user?.doctor_id,
            telecare_package_id: item.telecare_package_id,
            package_name:item.telecare_package_id.package_name,
            status: item.status,
            _id: item._id,
          }))
        );
        setTotalRows(res.totalResults);
      }
    });
  }, [table.page, table.rowsPerPage,user?.doctor_id]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Stack mb={3}>
        <Typography variant="h4">Telepackage Responses</Typography>
      </Stack>

      <TableContainer>
        <Scrollbar>
          <Table size={table.dense ? 'small' : 'medium'}>
            <TableHeadCustom headLabel={TABLE_HEAD} />

            <TableBody>
              {tableData.map((row, index) => (
                <TelePackageTableRow key={index} row={row} />
              ))}

              <TableNoData notFound={notFound} />
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>

      <TablePaginationCustom
        count={totalRows}
        page={table.page}
        rowsPerPage={table.rowsPerPage}
        onPageChange={(_, newPage) => table.setPage(newPage)}
        onRowsPerPageChange={(e) => {
          table.setRowsPerPage(parseInt(e.target.value, 10));
          table.setPage(0);
        }}
      />
    </Container>
  );
}
